var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServiceOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5625 6.0161L18.9235 2.60413H6.0766L3.4292 6.0161",
    stroke: "#674366",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 6.77079C3.125 6.49453 3.23475 6.22957 3.4301 6.03422C3.62545 5.83887 3.8904 5.72913 4.16667 5.72913H20.8333C21.1096 5.72913 21.3746 5.83887 21.5699 6.03422C21.7653 6.22957 21.875 6.49453 21.875 6.77079V20.8333C21.875 21.2477 21.7104 21.6451 21.4174 21.9381C21.1243 22.2312 20.7269 22.3958 20.3125 22.3958H4.6875C4.2731 22.3958 3.87567 22.2312 3.58265 21.9381C3.28962 21.6451 3.125 21.2477 3.125 20.8333V6.77079Z",
    stroke: "#674366",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 14.0624L12.5 18.2291L8.33337 14.0624M12.4959 9.89575V18.2291",
    stroke: "#674366",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServiceOne);
export default __webpack_public_path__ + "static/media/serviceOne.4b2e19fda43fa60669217e9076758ce7.svg";
export { ForwardRef as ReactComponent };